import { JOBPOSITION_FETCHING, JOBPOSITION_FAILED, JOBPOSITION_SUCCESS } from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case JOBPOSITION_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case JOBPOSITION_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case JOBPOSITION_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
}